/** Host detection for Notion / Google Docs cloud-document cards (same predicates as viewer `detectPlatform`). */
export function isGoogleDocsUrl(url) {
    if (!url)
        return false;
    return /docs\.google\.com/i.test(url);
}
export function isNotionUrl(url) {
    if (!url)
        return false;
    return /notion\.so|notion\.site/i.test(url);
}
export function cloudDocumentProviderLabel(url) {
    if (!url)
        return "document";
    if (isGoogleDocsUrl(url))
        return "docs";
    if (isNotionUrl(url))
        return "notion";
    return "document";
}
